import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import {  Autoplay , Navigation, Pagination  ,EffectFade, Controller} from 'swiper/modules';

function reviews() {
    
    const reviews_blocks = document.querySelectorAll('[data-block="reviews"]');
    
    reviews_blocks.forEach(block => {
        const reviews_slider = block.querySelector('[data-target="reviews_slider"]');
        if (!reviews_slider) { return; }
        const reviews_slider_pagination = reviews_slider.querySelector('.swiper-pagination')

        const slider = new Swiper(reviews_slider, {
            modules: [Pagination, Autoplay,EffectFade, Controller],
            loop: true,
            draggable: true,
            allowTouchMove: true,
            effect: 'slide',
            autoplay: {
                delay: 10000,
            },
            pagination: {
                el: reviews_slider_pagination,
                clickable: true,
            },
        });

        const reviews_slider_logos = block.querySelector('[data-target="reviews_slider_logos"]');
        if (!reviews_slider_logos) { return; }

        const logos_slider = new Swiper(reviews_slider_logos, {
            modules: [Pagination, Controller],
            loop: true,
            draggable: true,
            allowTouchMove: true,
            effect: 'slide',
            controller: {
                control: slider
            }
        });

        slider.controller.control = logos_slider;
    });
      
}


export { reviews }; 